import { createEnumHelper } from '@seiue/util'

import {
  CourseOutlineTaskTypeEnum,
  Outline,
  OutlineTaskCompletedReq,
  ReviewedStatusEnum,
  TaskCompletedDetail,
  courseApi,
} from 'packages/sdks-next/growp'

import { CourseAttachment, TreeOutline } from './types'
import { QuizMode } from '@/uikit/TestPaper/types'

/**
 * 格式化 outlines
 *
 * @param outlines - 外层大纲
 * @returns outlines
 */
export const formatOutlines = (outlines: Outline[]): TreeOutline[] =>
  outlines.map((outline) => ({
    ...outline,
    key: String(outline.id),
    title: outline.name || '',
    parentId: 0,
    children: outline.tasks?.map((task) => ({
      ...task,
      key: String(task.id),
      title: task.name || '',
      attachments: task.attachments as CourseAttachment[],
      parentId: outline.id,
    })),
    attachments: undefined,
  }))

/**
 * courseOutlineTaskTypeEnumToLabel
 *
 * @returns label of courseOutlineTaskTypeEnum
 */
export const courseOutlineTaskTypeEnumToLabel = createEnumHelper(() => ({
  [CourseOutlineTaskTypeEnum.Exercise]: '习题',
  [CourseOutlineTaskTypeEnum.Pdf]: 'PDF',
  [CourseOutlineTaskTypeEnum.Video]: '视频',
}))

export const courseOutlineTaskTypeEnumToDownloadLabel = createEnumHelper(
  () => ({
    [CourseOutlineTaskTypeEnum.Exercise]: '习题',
    [CourseOutlineTaskTypeEnum.Pdf]: '文件',
    [CourseOutlineTaskTypeEnum.Video]: '视频',
  })
)

/**
 * useUpdateOutlineComplete
 *
 * @returns useUpdateOutlineComplete
 */
export const useUpdateOutlineComplete = () => {
  const { api: modifyOutlineTaskCompleted } =
    courseApi.useModifyOutlineTaskCompleted({
      reload: [
        courseApi.loadCourseActivityTask,
        courseApi.queryCourseReflectionCompleted,
      ],
    })

  return async (props: {
    taskId: number
    id: number
    payload: OutlineTaskCompletedReq
  }) => {
    await modifyOutlineTaskCompleted(props)
  }
}

export const CourseReviewedStatusToQuizMode = createEnumHelper(() => ({
  [ReviewedStatusEnum.Reviewed]: QuizMode.Reviewed,
  [ReviewedStatusEnum.Submitted]: QuizMode.Completed,
  [ReviewedStatusEnum.Unsubmitted]: QuizMode.Answering,
  [ReviewedStatusEnum.Unviewed]: QuizMode.Completed,
}))
